import { Input } from 'antd';
import { Box } from '../../../box';
import { Block } from '../../../block';
import { useTranslation } from '../../../i18n';
import styles from '../style.module.less';
import { service } from '../service';
import { DragItem, Highlighter } from '../../component';
import { usePrimaryColor } from '../../hooks';
import type { ReactElement } from 'react';
import type { InputProps } from './types';

// 单行文本
export function InputDesignMode(props: InputProps): ReactElement {
  const [t] = useTranslation();
  const { rgbColor } = usePrimaryColor();
  // 拖拽时显示组件
  if (props.name == null) {
    return (
      <DragItem title={props.initTitle ?? ''} />
    );
  }

  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};

  return (
    <Box
      className={styles.designBox}
      style={{ ...activeStyle, paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title ?? t('Input')}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Block if={props.name != null}>
        <Box className={styles.input}>
          <Input
            type='text'
            placeholder={props.textPlaceholder ?? ''}
            value={props.value}
            readOnly={true}
          />
        </Box>
      </Block>
    </Box>
  );
}
